// extracted by mini-css-extract-plugin
export var box = "_5q-1";
export var checked = "_5q-2";
export var descriptionSpacer = "_5q-9";
export var disabled = "_5q-3";
export var icon = "_5q-6";
export var input = "_5q-0";
export var labelSpacer = "_5q-8";
export var medium = "_5q-5";
export var small = "_5q-4";
export var text = "_5q-7";